import { mapActions, mapState } from 'vuex';
import styled from 'vue-styled-components';
import { fontSize, width } from 'styled-system';
import { Section, Center, Row, Col, LoadingAnimation } from '@styled/global';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose(["\n   position: absolute;\n   right: 8px;\n   top: 8px;\n   height: 20px;\n   width: 20px;\n   cursor: pointer;\n\n   &::before {\n      display: block;\n      position: absolute;\n      content: \"\";\n      height: 20px;\n      width: 4px;\n      background-color: #6b5e51;\n      top: 10px;\n      right: 6px;\n      transform: translateX(-50%) translateY(-50%) rotate(45deg);\n   }\n\n   &::after {\n      display: block;\n      position: absolute;\n      content: \"\";\n      height: 20px;\n      width: 4px;\n      background-color: #6b5e51;\n      top: 10px;\n      right: 6px;\n      transform: translateX(-50%) translateY(-50%) rotate(-45deg);\n   }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose(["\n   text-align: left;\n   font-size: 12px;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n   text-align: left;\n   color: #333;\n   font-size: 16px;\n   padding-right: 60px;\n   margin-bottom: 10px;\n   font-weight: 700;\n   font-size: 16px;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n   border: 1px solid #aaa;\n   padding: 15px 15px 18px 15px;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n   position: relative;\n   background-color: #eee;\n   margin: 15px 0;\n   height: 0px;\n   position: relative;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n\n\tbackground: ", "\n\tcolor: #fff;\n\tmargin: 0;\n\tpadding: 0 20px;\n\theight: 40px;\n\tmargin-top: 16px;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n   text-align: left;\n   font-size: 11px;\n   margin: 4px 0 0 0;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n   background: blue;\n   border-radius: 50%;\n   color: #fff;\n   width: 18px;\n   height: 18px;\n   padding: 1px;\n   font-size: 16px;\n   font-weight: bold;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   cursor: pointer;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n   border: none;\n   outline: none;\n   background: transparent;\n   width: 100%;\n   padding: 0;\n   margin: 0 0 0 4px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   width: 30px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n   font-size: 18px;\n   font-weight: bold;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   border: 1px solid #000;\n   border-color: ", ";\n   padding: 8px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n   text-align: left;\n   font-size: 14px;\n   font-weight: 600;\n   margin: 0 0 2px 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: column;\n   width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   font-size: 11px;\n   line-height: 16px;\n   margin-top: 13px;\n   text-align: justify;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   display: block;\n   text-align: left;\n   color: ", ";\n   padding: 4px;\n\n   & strong {\n      color: ", ";\n   }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   white-space: nowrap;\n   height: 40px;\n   font-weight: 300;\n   -webkit-font-smoothing: antialiased;\n   vertical-align: middle;\n   text-align: left;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 100%;\n   padding: 0;\n   margin: 0;\n\n   & tr:nth-child(even) {\n      background: #eeeeee;\n   }\n\n   & tr:nth-child(odd) {\n      background: #fafafa;\n   }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   height: 40px;\n   font-size: 14px;\n   line-height: 18px;\n   -webkit-font-smoothing: antialiased;\n   vertical-align: middle;\n   text-align: left;\n   font-weight: bold;\n   padding: 4px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   border-spacing: 0;\n   width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Table = styled("table", {})(_templateObject());
var TableHeader = styled("th", {})(_templateObject2());
var TableBody = styled("tbody", {})(_templateObject3());
var TableRow = styled("tr", {})(_templateObject4());
var TableData = styled("td", {
  fontSize: {
    default: function _default() {
      return [0, 0, 3, 4];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject5(), fontSize); // export const Calculator = styled("div", {})`
//    display: flex;
//    flex-direction: column;
//    width: 100%;
//    border-top: 1px solid #ccc;
//    margin-top: 20px;
// `;

var Intro = styled("div", {
  fontSize: {
    default: function _default() {
      return [0, 0, 2, 3];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject6(), fontSize, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.secondaryColor;
});
var Footer = styled("div", {})(_templateObject7());
var Field = styled("div", {})(_templateObject8());
var Label = styled("label", {})(_templateObject9());
var InputBox = styled("div", {})(_templateObject10(), function (props) {
  return props.theme.secondaryColor;
});
var Prefix = styled("span", {})(_templateObject11());
var Suffix = styled("span", {})(_templateObject12());
var Input = styled("input", {})(_templateObject13());
var HelpIcon = styled("div", {})(_templateObject14());
var Hint = styled("div", {})(_templateObject15());
var Button = styled("button", {
  width: {
    default: function _default() {
      return ["100%", "100%", null];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject16(), width, function (props) {
  return props.theme.primaryColor;
});
var HelpArea = styled("div", {})(_templateObject17());
var HelpBox = styled("div", {})(_templateObject18());
var HelpHead = styled("div", {})(_templateObject19());
var HelpBody = styled("div", {})(_templateObject20());
var HelpClose = styled("a", {})(_templateObject21());

// Third party imports
//    <button {...data}>{children}</button>
// );

var Landscape = {
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    var _data$attrs = data.attrs,
        rates = _data$attrs.rates,
        copy = _data$attrs.copy,
        formatter = _data$attrs.formatter;
    var rowArray = []; // Create array of table columns

    var columnArray = []; // Create top header row starting with a blank column

    columnArray.push(h(TableHeader, {
      "key": "thBLANK",
      "style": {
        width: 3 / 12 + "%"
      }
    }, ["\xA0"]));
    copy.details.map(function (item, itemIndex) {
      var width = itemIndex === 3 ? 3 / 12 : 2 / 12;
      columnArray.push(h(TableHeader, {
        "key": itemIndex,
        "style": {
          width: width + "%"
        }
      }, [item.label]));
      return null;
    });
    rowArray.push(h(TableRow, {
      "key": "trTOP"
    }, [columnArray])); // Iterate through an array of products defined in the copy

    copy.products.map(function (product, prodIndex) {
      // Locate matching product
      var nextProduct = rates.mortgageProducts.find(function (productFind) {
        return productFind.productCode === product.productCode;
      }); // Clear array of columns

      columnArray = []; // Start each row with table header

      columnArray.push(h(TableHeader, {
        "key": "th" + prodIndex,
        "style": {
          padding: "0 0 0 10px"
        }
      }, [product.label])); // Iterate through each item in the detail section using the associated property to lookup the value from the app data

      copy.details.map(function (item, itemIndex) {
        var formatterNumber = formatter(item.format, nextProduct.rateDetails[item.property]);
        columnArray.push(h(TableData, {
          "class": "data-cell",
          "key": itemIndex
        }, [formatterNumber]));
        return null;
      });
      rowArray.push(h(TableRow, {
        "class": "data-row",
        "key": "tr" + prodIndex
      }, [columnArray]));
      return null;
    });
    return h(Table, [h(TableBody, [rowArray])]);
  }
};

// Third party imports
var Portrait = {
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    // Create array of table rows
    var _data$attrs = data.attrs,
        rates = _data$attrs.rates,
        copy = _data$attrs.copy,
        formatter = _data$attrs.formatter; // Create array of table rows

    var rowArray = []; // Create array of table columns

    var columnArray = []; // Create top header row starting with a blank column

    columnArray.push(h(TableHeader, {
      "key": "thBLANK",
      "style": {
        width: 1 / 4 + "%"
      }
    }, ["\xA0"]));
    copy.products.map(function (product, productIndex) {
      columnArray.push(h(TableHeader, {
        "key": productIndex,
        "style": {
          width: 1 / 4 + "%"
        }
      }, [product.label]));
      return null;
    });
    rowArray.push(h(TableRow, {
      "key": "trTOP"
    }, [columnArray])); // Iterate through an array of details defined in the copy

    copy.details.map(function (detail, detailIndex) {
      // Clear array of columns
      columnArray = []; // Start each row with table header

      columnArray.push(h(TableHeader, {
        "key": "th" + detailIndex,
        "style": {
          padding: "0 0 0 10px"
        }
      }, [detail.label])); // Iterate through each item in the product section using the associated property to lookup the value from the app data

      copy.products.map(function (product, prodIndex) {
        var nextProduct = rates.mortgageProducts.find(function (productFind) {
          return productFind.productCode === product.productCode;
        }); // const nextProduct = find( rates.mortgageProducts, { 'productCode': product.productCode, 'productSubCode': product.productSubCode });

        var formatterNumber = formatter(detail.format, nextProduct.rateDetails[detail.property]);
        columnArray.push(h(TableData, {
          "attrs": {
            "fontSize": 14
          },
          "key": prodIndex
        }, [formatterNumber]));
        return null;
      });
      rowArray.push(h(TableRow, {
        "key": "tr" + detailIndex
      }, [columnArray]));
      return null;
    });
    return h(Table, [h(TableBody, [rowArray])]);
  }
};

var script = {
  name: "TransitionExpand",
  functional: true,
  render: function render(createElement, context) {
    var data = {
      props: {
        name: "expand"
      },
      on: {
        afterEnter: function afterEnter(element) {
          // eslint-disable-next-line no-param-reassign
          element.style.height = "auto";
        },
        enter: function enter(element) {
          var _getComputedStyle = getComputedStyle(element),
              width = _getComputedStyle.width;
          /* eslint-disable no-param-reassign */


          element.style.width = width;
          element.style.position = "absolute";
          element.style.visibility = "hidden";
          element.style.height = "auto";
          /* eslint-enable */

          var _getComputedStyle2 = getComputedStyle(element),
              height = _getComputedStyle2.height;
          /* eslint-disable no-param-reassign */


          element.style.width = null;
          element.style.position = null;
          element.style.visibility = null;
          element.style.height = 0;
          /* eslint-enable */
          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions

          getComputedStyle(element).height;
          requestAnimationFrame(function () {
            // eslint-disable-next-line no-param-reassign
            element.style.height = height;
          });
        },
        leave: function leave(element) {
          var _getComputedStyle3 = getComputedStyle(element),
              height = _getComputedStyle3.height; // eslint-disable-next-line no-param-reassign


          element.style.height = height; // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions

          getComputedStyle(element).height;
          requestAnimationFrame(function () {
            // eslint-disable-next-line no-param-reassign
            element.style.height = 0;
          });
        }
      }
    };
    return createElement("transition", data, context.children);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1ee8bd6b_0", { source: "*[data-v-1ee8bd6b]{will-change:height;transform:translateZ(0);backface-visibility:hidden;perspective:1000px}", map: undefined, media: undefined })
,inject("data-v-1ee8bd6b_1", { source: ".expand-enter-active,.expand-leave-active{transition:height .5s;overflow:hidden}.expand-enter,.expand-leave-to{height:0}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1ee8bd6b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Third party imports
var Field$1 = {
  props: {
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      type: String,
      default: ""
    },
    hint: {
      required: false,
      type: String,
      default: null
    },
    label: {
      required: false,
      type: String,
      default: null
    },
    symbol: {
      required: false,
      type: String,
      default: null
    },
    helpHead: {
      required: false,
      type: String,
      default: null
    },
    helpBody: {
      required: false,
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      showHelp: false
    };
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    }
  },
  components: {
    TransitionExpand: __vue_component__
  },
  render: function render() {
    var h = arguments[0];
    var label = this.label + " " + (this.required ? "*" : null);
    var helpIcon = this.helpHead ? h(Suffix, [h(HelpIcon, {
      "on": {
        "click": this.toggleHelp
      }
    }, ["?"])]) : null; // const helpArea = this.showHelp ? (
    //    <HelpArea>
    //       <HelpBox>
    //          <HelpClose onclick={this.toggleHelp} />
    //          <HelpHead>{this.helpHead}</HelpHead>
    //          <HelpBody>{this.helpBody}</HelpBody>
    //       </HelpBox>
    //    </HelpArea>
    // ) : null;

    return h(Field, [h(Label, [label]), h(InputBox, [this.symbol && h(Prefix, [this.symbol]), h(Input, {
      "attrs": {
        "value": this.value
      }
    }), helpIcon]), h(Hint, [this.hint]), h(__vue_component__, [this.showHelp && h(HelpArea, [h(HelpBox, [h(HelpClose, {
      "on": {
        "click": this.toggleHelp
      }
    }), h(HelpHead, [this.helpHead]), h(HelpBody, [this.helpBody])])])])]);
  }
};

var script$1 = {
  data: function data() {
    return {
      numberFormatter: null
    };
  },
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  components: {
    Landscape: Landscape,
    Portrait: Portrait,
    Field: Field$1
  },
  methods: _extends({}, mapActions("mortgage-rates", ["loadRates"]), {
    baseOnText: function baseOnText() {
      if (this.rates) {
        var basedOn = this.copy.basedOn;
        basedOn = basedOn.replace("${loadAmount}", "$" + this.rates.rateInputs.amountBorrowed.toLocaleString());
        basedOn = basedOn.replace("${zipCode}", this.rates.rateInputs.postalCode.toLocaleString());
        return basedOn;
      }

      return null;
    }
  }),
  computed: _extends({}, mapState("mortgage-rates", ["rates"]), {}, mapState("viewport", ["breakpoint"])),
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var numberFormatter;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadRates();

            case 2:
              _context.next = 4;
              return import(
              /* webpackChunkName: "number-formatter" */
              'number-formatter');

            case 4:
              numberFormatter = _context.sent;
              _this.numberFormatter = numberFormatter.default;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];

    //       <Calculator>
    //    <CalcIntro domPropsInnerHTML={this.calcIntro()} />
    // </Calculator>
    if (this.rates && this.numberFormatter) {
      var formatterNumber = this.numberFormatter("#,###.###%", 3.625);
      var isMobile = this.breakpoint === "xs" || this.breakpoint === "sm";

      var renderTable = function renderTable() {
        if (isMobile) {
          return h(Portrait, {
            "attrs": {
              "copy": _this2.copy,
              "rates": _this2.rates,
              "formatter": _this2.numberFormatter
            }
          });
        } else {
          return h(Landscape, {
            "attrs": {
              "copy": _this2.copy,
              "rates": _this2.rates,
              "formatter": _this2.numberFormatter
            }
          });
        }
      };

      return h(Section, {
        "attrs": {
          "padding": ["20px"]
        }
      }, [h(Center, {
        "attrs": {
          "flexDirection": "column"
        }
      }, [h(Row, {
        "style": {
          borderTop: "1px solid #eee",
          paddingTop: "20px",
          marginBottom: "20px"
        }
      }, [h(Col, {
        "attrs": {
          "width": [8]
        }
      }, [h(Intro, {
        "domProps": {
          "innerHTML": this.baseOnText()
        }
      })]), h(Col, {
        "attrs": {
          "width": [4]
        },
        "style": {
          borderLeft: "1px solid #000"
        }
      }, [h(Intro, {
        "domProps": {
          "innerHTML": this.copy.customRate
        }
      })])]), h(Row, [h(Col, {
        "attrs": {
          "mb": "12px",
          "width": [12, 12, 4, 3]
        }
      }, [h(Field$1, {
        "attrs": {
          "symbol": "$",
          "label": "Purchase price",
          "required": true,
          "value": "225,000",
          "hint": "$60,000 - $2.5 million",
          "helpHead": "Purchase price",
          "helpBody": "Input range $10,000 - $1.5 million"
        }
      })]), h(Col, {
        "attrs": {
          "mb": "12px",
          "width": [12, 12, 4, 3]
        }
      }, [h(Field$1, {
        "attrs": {
          "symbol": "$",
          "label": "Down payment",
          "required": true,
          "value": "6,000",
          "hint": "5% or more of purchase price",
          "helpHead": "Amount down",
          "helpBody": "5% or more of purchase price"
        }
      })]), h(Col, {
        "attrs": {
          "mb": "12px",
          "width": [12, 12, 4, 3]
        }
      }, [h(Field$1, {
        "attrs": {
          "label": "Zip code",
          "required": true,
          "value": "80124"
        }
      })]), h(Col, {
        "attrs": {
          "mb": "12px",
          "width": [12, 12, 12, 3],
          "flexDirection": "row",
          "justifyContent": "left",
          "alignItems": "flex-start"
        }
      }, [h(Button, ["Update Rates"])])]), renderTable(), h(Footer, [this.copy.footer])])]);
    }

    return h(Section, {
      "attrs": {
        "height": ["422px", "422px", "374px", "374px", "374px"]
      }
    }, [h(Center, [h(LoadingAnimation)])]);
  }
}; // Store loader function called by LazyContainer to dynamically preload stores required by this component

var storeLoader = function storeLoader() {
  return function () {
    return [{
      name: "mortgage-rates",
      store: function store() {
        return import(
        /* webpackChunkName: "mortgage-rates-store" */
        '@stores/mortgage-rates');
      }
    }];
  };
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$1;
export { storeLoader };
